import BaseCtrl from 'edge/platform/base/BaseCtrl';

/**
 * This function prepares some common actions to be used in flow configuration
 *
 * @param {Object} dependencies
 * @param {Object} dependencies.$q a Promise implementation
 * @param {Object} dependencies.LoadSaveService
 * @param {Object} dependencies.ViewModelService
 * @param {Object} dependencies.ViewModelContext
 *
 * @returns {Object} a set of common Flow actions 'ret.ACTIONS' an their respective message 'ret.ACTIONS_MSG' to be used across all the custom flows
 */

const fn = ($scope, ClaimService, $translate, ViewModelService, ModalService) => {
    const ctrl = Object.create(BaseCtrl);


    $scope.data = [];
    const viewModel = {};

    const today = new Date();

    $scope.today = {
        year: today.getFullYear(),
        month: today.getMonth(),
        day: today.getDate()
    };

    ctrl.init = () => {
        if (PSAUSER !== undefined) {
            if (PSAUSER.isDelearLeadOrAudit === undefined || PSAUSER.isDelearLeadOrAudit === false) {
                ModalService.showError('gateway.views.modal.Error', 'gPermission Denied');
                return false;
            }
            else {
                $scope.submissionView = ViewModelService.create(viewModel, 'cc', 'edge.capabilities.claim.dto.ReportDTO');
            }
        }
    };

    ctrl.cancel = function () {
        window.location.hash = '#/PUWReport/';
    };

    ctrl.disableGenerateReport = function (form) {
        if ($scope.submissionView.closed.value == true
            || $scope.submissionView.open.value == true) {
            $scope.submissionView.status.value = true;
        } else {
            $scope.submissionView.status.value = undefined;
        }
        return !$scope.form.valid;
    }

    ctrl.save = function (form) {
        var firstDate = new Date($scope.submissionView.value.fromDate.year,
            $scope.submissionView.value.fromDate.month, $scope.submissionView.value.fromDate.day)
        var lastDate = new Date($scope.submissionView.value.toDate.year,
            $scope.submissionView.value.toDate.month, $scope.submissionView.value.toDate.day)
        var fDate = moment(firstDate)
        var lDate = moment(lastDate)
        //INCI11796175 -  ISSUE WITH REPORTS ON THE PORTAL
        var MonthsDiff = moment.duration(lDate.diff(fDate)).asMonths();
        var daysDiff = moment.duration(lDate.diff(fDate)).asDays();
        if (MonthsDiff > 3 && (daysDiff > 90 || daysDiff < 0) || MonthsDiff < 0) {
            ModalService.showError('gateway.views.modal.Error', 'PSA.Web.PSAReport.timeframe');
            return;
        }

        const operation = ClaimService.getClaimsForReport($scope.submissionView.value);
        console.log($scope.submissionView.value);
        operation.then((result) => {
            if (result.length > 0) {
                $scope.RRDI = result[0].dealerRRDI;
                $scope.data = _.sortBy(result, 'claimNumber');
                JSONToCSVConvertor($scope.data, 'Claim Report', true);
            } else {
                // UCWPRODENG-813 - R4 Staging Portal Report dealer KO error message when generate report
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.policy-summary.No results found for this filter');
            }
        }).catch((error) => {
            ModalService.showError('gateway.views.modal.Error', 'PSA.Web.PSAReport.error');
        });

    };
    function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
        // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        const arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

        let CSV = 'sep=,' + '\r\n\n';

        //
        const firstDate = new Date($scope.submissionView.value.fromDate.year,
            $scope.submissionView.value.fromDate.month, $scope.submissionView.value.fromDate.day);
        const lastDate = new Date($scope.submissionView.value.toDate.year,
            $scope.submissionView.value.toDate.month, $scope.submissionView.value.toDate.day);
        const fDate = moment(firstDate);
        const lDate = moment(lastDate);
        // This condition will generate the Label/Header
        const rowTitle = $translate.instant('PSA.Web.PSAReport.Claim-Dealer-Report') + ",";
        CSV += rowTitle + '\r\n';
        const row1 = $translate.instant('PSA.Web.PSAReport.Claim-Report-Dates') + ": " + $translate.instant('PSA.Web.PSAReport.fromDate') + ': ' + fDate.format('DD/MM/YYYY') + ' ' + $translate.instant('PSA.Web.PSAReport.toDate') + ': ' + lDate.format('DD/MM/YYYY') + ',';
        CSV += row1 + '\r\n';
        if ($scope.submissionView.open.value !== undefined && $scope.submissionView.open.value == true) {
            var row2 = $translate.instant('PSA.Web.PSAReport.open') + ',';
            CSV += row2 + '\r\n';
        }
        if ($scope.submissionView.closed.value !== undefined && $scope.submissionView.closed.value == true) {
            var row2 = $translate.instant('PSA.Web.PSAReport.closed') + ',';
            CSV += row2 + '\r\n';
        }
        CSV += '\r\n';

        // Headers
        const headerArray = {
            'dealerRRDI': $translate.instant('PSA.Web.PSAReport.Header.Dealer-RRDI'),
            'repairerRRDI': $translate.instant('PSA.Web.PSAReport.Header.Repairer-RRDI'),
            'policyNumber': $translate.instant('PSA.Web.PSAReport.Header.Policy-Number'),
            'claimNumber': $translate.instant('PSA.Web.PSAReport.Header.Claim-Number'),
            'country': $translate.instant('PSA.Web.PSAReport.Header.Country'),
            'claimStatus': $translate.instant('PSA.Web.PSAReport.Header.Claim-Status'),
            'closureReason': $translate.instant('PSA.Web.PSAReport.Header.Closure-Reason'),
            'coverageInQuestion': $translate.instant('PSA.Web.PSAReport.Header.Coverage-In-Question'),
            'vin': $translate.instant('PSA.Web.PSAReport.Header.VIN'),
            'brand': $translate.instant('PSA.Web.PSAReport.Header.Brand'),
            'model': $translate.instant('PSA.Web.PSAReport.Header.Model'),
            'cause': $translate.instant('PSA.Web.PSAReport.Header.Cause'),
            'claimDefault': $translate.instant('PSA.Web.PSAReport.Header.Default'),
            'mileage': $translate.instant('PSA.Web.PSAReport.Header.Mileage'),
            'claimDate': $translate.instant('PSA.Web.PSAReport.Header.Claim-Date'),
            'subscriptionDate': $translate.instant('PSA.Web.PSAReport.Header.Subscription-Date'),
            'mileageAtSubDate': $translate.instant('PSA.Web.PSAReport.Header.Mileage-At-Subscription-Date'),
            'amountToPayWithVAT': $translate.instant('PSA.Web.PSAReport.Header.Amount-To-Pay-With-VAT'),
            'amountToPayWithoutVAT': $translate.instant('PSA.Web.PSAReport.Header.Amount-To-Pay-Without-VAT'),
            'amountToPayVAT': $translate.instant('PSA.Web.PSAReport.Header.Amount-To-Pay-VAT'),
            'producerCompanyName': $translate.instant('PSA.Web.PSAReport.Header.Producer-Company-Name'),
            'lossDate': $translate.instant('PSA.Web.PSAReport.Header.Loss-Date'),
            'amountChargeSeller': $translate.instant('PSA.Web.PSAReport.Header.Amount-Charge-Seller'),
            'amountChargeSellerWithoutVAT': $translate.instant('PSA.Web.PSAReport.Header.Amount-Charge-Seller-Without-VAT'),
            'amountChargeSellerVAT': $translate.instant('PSA.Web.PSAReport.Header.Amount-Charge-Seller-VAT')
        };
        if (ShowLabel) {
            let row = '';

            // This loop will extract the label from 1st index of on array
            for (const key in headerArray) {
                row += `${headerArray[key]},`;
            }
            // for (var index in arrData[0]) {

            //     //Now convert each value to string and comma-seprated
            //     row += index.toUpperCase() + ',';
            // }
            row = row.slice(0, -1);
            // append Label row with line break
            CSV += `${row}\r\n`;
        }
        // 1st loop is to extract each row
        for (let i = 0; i < arrData.length; i++) {
            let row = '';
            // 2nd loop will extract each column and convert it in string comma-seprated
            for (const key in headerArray) {
                if (arrData[i][key] == undefined) {
                    row += '"' + '-' + '",';
                }
                else {
                    row += `"${arrData[i][key]}",`;
                }
            }

            row.slice(0, row.length - 1);
            // add a line break after each row
            CSV += `${row}\r\n`;
        }
        if (CSV == '') {
            return;
        }
        // Generate a file name
        let fileName = $scope.RRDI + "_Stellantis_Claim Dealer Report_" + moment(new Date()).format('MM/DD/YYYY');
        // this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, '_');
        // Initialize file format you want csv or xls
        const uri = `data:text/csv;charset=utf-8,${escape(CSV)}`;

        const link = document.createElement('a');
        link.href = uri;
        // set the visibility hidden so it will not effect on your web-layout
        link.style = 'visibility:hidden';
        link.download = `${fileName}.csv`;
        // this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return ctrl.create($scope);
};

fn.$inject = ['$scope', 'claim.ClaimService', '$translate', 'ViewModelService', 'ModalService'];
export default fn;
